/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import parse from 'html-react-parser';

interface Props {
  children?: any;
  title?: string;
  description?: string;
  noindex?: boolean;
}
function SEO({ description, title, children, noindex }: Props) {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `);

  const metaDescription = description || site.siteMetadata.description;
  const metaTitle = title || site.siteMetadata?.title;

  return (
    <>
      <title>{parse(metaTitle)}</title>
      <meta
        name="description"
        content={metaDescription}
      />
      <meta
        name="robots"
        content="noodp,noydir"
      />
      <meta
        name="format-detection"
        content="telephone=no"
      />
      <meta
        name="robots"
        content="max-snippet:-1, max-image-preview:large"
      />
      {noindex && (
        <meta
          name="robots"
          content="noindex"
        />
      )}
      {children}
    </>
  );
}

export default SEO;
